export const PERFORMANCE_METRICS = 'performanceMetrics'
export const ENGAGEMENT_METRICS = 'engagementMetrics'
export const VIDEO_METRICS = 'videoMetrics'
export const CONVERSION_METRICS = 'conversionMetrics'
export const CUSTOM_CONVERSIONS = 'custom_conversions'
export const CUSTOM_EVENTS = 'custom_events'

const performanceMetricsLabels = {
  reach: 'Reach',
  frequency: 'Frequency',
  impressions: 'Impressions',
  cpm: 'CPM (cost per 1,000 impressions)',
  spend: 'Spend',
  clicks: 'Clicks (all)',
  ctr: 'CTR (all)',
  cpc: 'CPC (all)',
  inline_link_clicks: 'Link Clicks',
  inline_link_click_ctr: 'CTR (link clicks)',
  attribution_setting: 'Attribution Setting'
}

const engagementMetricsLabels = {
  page_engagement: 'Page Engagement',
  follows_or_likes: 'Follows or Likes',
  ad_comments: 'Ad Comments',
  ad_engagements: 'Ad Engagements',
  ad_reactions: 'Ad Reactions',
  ad_saves: 'Ad Saves',
  ad_shares: 'Ad Shares'
}

const videoMetricsLabels = {
  video_3_sec_watched_actions: '3-second video plays',
  video_thruplay_watched_actions: 'Thruplays',
  video_p25_watched_actions: 'Video plays at 25%',
  video_p50_watched_actions: 'Video plays at 50%',
  video_p75_watched_actions: 'Video plays at 75%',
  video_p95_watched_actions: 'Video plays at 95%',
  video_p100_watched_actions: 'Video plays at 100%',
  video_avg_time_watched_actions: 'Video average play time',
  video_play_actions: 'Video plays'
}

const conversionMetricsLabels = {
  adds_to_cart: 'Adds to cart',
  app_installs: 'App installs',
  checkouts_initiated: 'Checkouts Initiated',
  landing_page_views: 'Landing page views',
  leads: 'Leads',
  purchases: 'Purchases',
  purchase_roas: 'Purchase ROAS',
  registrations_completed: 'Registrations Completed',
  searches: 'Searches'
}

export const performanceMetricsOptions = Object.entries(performanceMetricsLabels).map(([key, label]) => ({
  value: key,
  label
}))

export const engagementMetricsOptions = Object.entries(engagementMetricsLabels).map(([key, label]) => ({
  value: key,
  label
}))

export const videoMetricsOptions = Object.entries(videoMetricsLabels).map(([key, label]) => ({
  value: key,
  label
}))

export const conversionMetricsOptions = Object.entries(conversionMetricsLabels).map(([key, label]) => ({
  value: key,
  label
}))

export const breakdownOptions = [
  { value: 'gender', label: 'Gender' },
  { value: 'age', label: 'Age' },
  { value: 'country', label: 'Country' },
  { value: 'region', label: 'Region' },
  { value: 'dma', label: 'DMA' },
  { value: 'impression_device', label: 'Impression Device' },
  { value: 'placement', label: 'Placement' },
  { value: 'time_of_day_ad_account_time_zone', label: 'Time of Day (Ad Account Time Zone)' },
  { value: 'time_of_day_viewer_time_zone', label: 'Time of Day (Viewer Time Zone)' },
  { value: 'platform', label: 'Platform' },
  { value: 'carousel_card', label: 'Carousel Card' },
  { value: 'destination', label: 'Destination' },
  { value: 'device', label: 'Device' },
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'two_weeks', label: 'Two Weeks' },
  { value: 'month', label: 'Month' }
]

export const METRICS = 'metrics'
export const BREAKDOWNS = 'breakdowns'
export const LEVEL = 'level'

export const exportAsCsvLevels = {
  campaign: 'campaign',
  lineItem: 'line_item',
  ad: 'ad'
}

export const getInitialValues = level => {
  return {
    [METRICS]: {
      [PERFORMANCE_METRICS]: Object.fromEntries(Object.keys(performanceMetricsLabels).map(key => [key, false])),
      [ENGAGEMENT_METRICS]: Object.fromEntries(Object.keys(engagementMetricsLabels).map(key => [key, false])),
      [VIDEO_METRICS]: Object.fromEntries(Object.keys(videoMetricsLabels).map(key => [key, false])),
      [CONVERSION_METRICS]: Object.fromEntries(Object.keys(conversionMetricsLabels).map(key => [key, false]))
    },
    [CUSTOM_CONVERSIONS]: {},
    [CUSTOM_EVENTS]: {},
    [BREAKDOWNS]: [],
    [LEVEL]: level
  }
}
